import { readSessionClock } from '@socialgoodsoftware/components';
import { notifySessionActivity } from './session-activity';

/** The session middleware answers every authenticated request with the row's remaining time and the org policy. */
function readSessionHeaders(headers: Headers): void {
  notifySessionActivity(readSessionClock(headers));
}

export { readSessionHeaders };
